import { render, staticRenderFns } from "./InscripcionBeneficioView.vue?vue&type=template&id=2599f109&"
import script from "./InscripcionBeneficioView.vue?vue&type=script&lang=ts&"
export * from "./InscripcionBeneficioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports